import * as React from 'react';
import { Menu, Dropdown, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
const CustomDropDown = ({ dropDownButton, dropDownElements, onclickMenu, rowId }: any) => {
    const rowIdConst = rowId;
    const menu = (
        <Menu onClick={( key: any) => onclickMenu(rowIdConst, key)}>
            {
                dropDownElements.map(
                    (eachElement: any) => 
                    <Menu.Item key={eachElement.key} icon={eachElement.icon ? eachElement.icon : ''}>
                        {eachElement.name}
                    </Menu.Item>
                )
            }
        </Menu>
    );
    return (
        <Dropdown overlay={menu} trigger={['click']}>
            <Button className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                {dropDownButton.name}
                <DownOutlined /> 
            </Button>
        </Dropdown>);
}

export default CustomDropDown;